<template>
    <div class="subPage">
        <!-- 头部 -->
        <Header
            v-if="init"
            :rankBy="rankBy"
            :selectRankBy="selectRankBy"
            :userInfo="userInfo"
            :topProfit="topProfit.list.filter((s, i) => i <= 2 )"
            :users="topProfit.users"
            :ownRank="ownRank"
        />
        <!-- 更新时间 -->
        <div class="flex flexCenter">
            <p>更新时间： <span>{{ TimeFormat(topProfit.reflashDate) }}</span></p>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a @click="() => { this.$store.dispatch('user/getProfitRealTime', this.rankBy); }">刷新</a>
        </div>
        <!-- 表格 -->
        <Table
            v-if="init"
            :topProfit="topProfit.list.filter((s, i) => i > 2 )"
            :users="topProfit.users"
        />
      <go-back-home/>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { TimeFormat } from '../../utils/utils';
import Header from '../userRankElement/Header';
import Table from '../userRankElement/Table';

export default {
  watch: {
      rankBy: function(val) {
          this.$store.dispatch('user/getProfitRealTime', val);
      },
      topProfit: function(val) {
          this.init = true;
      }
  },
  name: 'Rank',
  meta:{page:true},
  data() {
    return {
        init: false,
    }
  },
  computed: {
        ...mapGetters('userinterface', {
            rankBy: 'getRankBy'
        }),
        ...mapGetters('user', {
            userInfo: 'getUserInfo',
            topProfit: 'getTopProfit',
            ownRank: 'getOwnRank'
        })
  },
  methods: mapActions('userinterface', [
      'selectRankBy'
  ]),
  components: {
      Header,
      Table
  },
  created() {
      this.$store.dispatch('user/getProfitRealTime', this.rankBy);
      this.TimeFormat = TimeFormat;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subPage {
    margin-bottom: 0 !important;
}
.flexCenter {
    justify-content: center;
    margin: .16rem 0;
}
.flexCenter p {
    color: #373737;
    font-size: .16rem;
}
.flexCenter a {
    font-size: .16rem;
    color: #329fd9;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Rank.vue